import { render, staticRenderFns } from "./AddEditProperty.vue?vue&type=template&id=5838e8dd&"
import script from "./AddEditProperty.vue?vue&type=script&lang=js&"
export * from "./AddEditProperty.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports